import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_B2B_BIZ_USER, IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { SHARING_FOLDERS_REDESIGN_BIZ, SHARING_REDESIGN_BIZ } from 'reactApp/appHelpers/featuresHelpers/features/sharingRedesignBiz';
import { CSAT_TRIGGER_EVENTS, pushCSATTriggerEvent } from 'reactApp/modules/promo/sagas/initCSATSurvey';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { AccessRights } from 'reactApp/types/Tree';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { renderPreCopyWeblink } from 'reactApp/ui/CopyWeblink/PreCopyWeblinkDialog/preCopyWeblink.helpers';
import { useCopyWeblink } from 'reactApp/ui/CopyWeblink/useCopyWeblink';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

interface Props {
    isPhone?: boolean;
    isFolder: boolean;
    isDownloadable?: boolean;
    fileName?: string;
    weblinkDomestic?: boolean;
    weblinkAccessRights?: AccessRights;
    publicUrl: string;
}

export const CopyLink = ({ isPhone, isFolder, isDownloadable, fileName, publicUrl, weblinkDomestic, weblinkAccessRights }: Props) => {
    const dispatch = useDispatch();
    const isReadWriteWeblinkAccess = weblinkAccessRights && weblinkAccessRights === AccessRights.write;
    const isBizUser = useSelector(UserSelectors.isBizUser);

    const { copy } = useCopyWeblink({
        isPhone,
        isFolder,
        isDownloadable,
        isReadWriteWeblinkAccess,
    });

    const renderPreCopyDialog = useCallback(() => {
        renderPreCopyWeblink({ onSuccess: () => copy(publicUrl), fileName });
    }, [copy, fileName, publicUrl]);

    const handleCopyButtonClick = useCallback(() => {
        if (!isFolder && IS_B2B_BIZ_USER && !IS_ONPREMISE && !weblinkDomestic) {
            return renderPreCopyDialog();
        }

        copy(publicUrl);

        const isBizRedesign = SHARING_FOLDERS_REDESIGN_BIZ || SHARING_REDESIGN_BIZ;
        let userType = 'b2c';
        if (isBizUser) {
            userType = isBizRedesign ? 'biz' : 'biz-old';
        }
        const itemType = isFolder ? 'folder' : 'file';

        sendDwh({
            eventCategory: ECategoryGa.public,
            action: 'copy-weblink',
            label: userType,
            dwhData: {
                item_type: itemType,
            },
        });

        dispatch(pushCSATTriggerEvent({ type: CSAT_TRIGGER_EVENTS.copyWeblink }));
    }, [isFolder, weblinkDomestic, copy, publicUrl, isBizUser, dispatch, renderPreCopyDialog]);

    return (
        <Button theme={isPhone ? 'vk' : 'octavius'} primary sizeMode={ButtonSizeMode.small} onClick={handleCopyButtonClick}>
            Скопировать ссылку
        </Button>
    );
};
